import { computed } from 'vue'
import { useGlobalConfig } from '@pit-element-plus/components/config-provider'
import type { FormBaseProps } from './form-base'

export default function useFormBase(props: FormBaseProps) {
  const pageSize = useGlobalConfig('pageSize')
  const pageNum = useGlobalConfig('pageNum')
  const isHiddenAddBtn = useGlobalConfig('isHiddenAddBtn')
  const isHiddenEditBtn = useGlobalConfig('isHiddenEditBtn')
  const isHiddenDelBtn = useGlobalConfig('isHiddenDelBtn')
  const isHiddenBatchBtn = useGlobalConfig('isHiddenBatchBtn')
  const buttonArea = useGlobalConfig('buttonArea')

  // 是否隐藏新建按钮
  const hiddenAddBtn = computed(
    () => props.noAddBtn && isHiddenAddBtn.value === 'show'
  )

  // 是否隐藏编辑按钮
  const hiddenEditBtn = computed(
    () => props.noEditBtn && isHiddenEditBtn.value === 'show'
  )

  // 是否隐藏删除按钮
  const hiddenDelBtn = computed(
    () => props.noDelBtn && isHiddenDelBtn.value === 'show'
  )

  // 是否隐藏批量删除按钮
  const hiddenBatchBtn = computed(
    () => props.noBatchBtn && isHiddenBatchBtn.value === 'show'
  )

  // 是否隐藏表格上面的操作按钮
  const isButtonAreaType = computed(() => buttonArea.value === 'default')

  const searchTypeStr = useGlobalConfig('searchType')
  const clearTypeStr = useGlobalConfig('clearType')
  const addTypeStr = useGlobalConfig('addType')
  const updateTypeStr = useGlobalConfig('updateType')
  const deleteTypeStr = useGlobalConfig('deleteType')
  const batchDelTypeStr = useGlobalConfig('batchDelType')
  const expandTypeStr = useGlobalConfig('expandType')
  const saveTypeStr = useGlobalConfig('saveType')
  const cancelTypeStr = useGlobalConfig('cancelType')
  const paginationTotal = useGlobalConfig('paginationTotal')
  const draftBtnTypeStr = useGlobalConfig('draftBtnType')
  const initiateProcessBtnTypeStr = useGlobalConfig('initiateProcessBtnType')
  const columnsStr = useGlobalConfig('columns')

  const globalDoubleClickDetails = useGlobalConfig('globalDoubleClickDetails')
  const flowStatusData = useGlobalConfig('flowStatusData')
  const defaultFlowStatus = useGlobalConfig('defaultFlowStatus')
  const flowStatusWidth = useGlobalConfig('flowStatusWidth')

  const customSetUpRender = useGlobalConfig('customSetUpRender')
  const customSetUpCallback = useGlobalConfig('customSetUpCallback')

  const paginationPageSizeStr = useGlobalConfig('paginationPageSize')
  const paginationPageNumStr = useGlobalConfig('paginationPageNum')

  return {
    pageSize,
    pageNum,
    hiddenAddBtn,
    hiddenEditBtn,
    hiddenDelBtn,
    hiddenBatchBtn,
    isButtonAreaType,
    searchTypeStr,
    clearTypeStr,
    addTypeStr,
    updateTypeStr,
    deleteTypeStr,
    batchDelTypeStr,
    expandTypeStr,
    saveTypeStr,
    cancelTypeStr,
    paginationTotal,
    draftBtnTypeStr,
    initiateProcessBtnTypeStr,
    columnsStr,
    globalDoubleClickDetails,
    flowStatusData,
    defaultFlowStatus,
    flowStatusWidth,
    customSetUpRender,
    customSetUpCallback,
    paginationPageSizeStr,
    paginationPageNumStr,
  }
}
